import React, {useContext} from 'react'
import ThemeLeftMenuSideBar from './ThemeLeftMenuSideBar'
import ThemeBody from './ThemeBody'
import ThemeTopBar from './ThemeTopBar'
import ThemeContent from './ThemeContent'
import ThemeContext from '../../Context/ThemeContext'
import Loader from '../../Components/Loader';


function Template({children}) {
  const {isMobile, isLoading} = useContext(ThemeContext);
  return (
    <>
      {isLoading && <Loader />}
      <div className="page-container d-flex">
        {!isMobile && <ThemeLeftMenuSideBar/> }
        <ThemeBody>
          <ThemeTopBar/>
          <ThemeContent>      
            {children}
          </ThemeContent>
        </ThemeBody>
      </div>      
    </>    
  )
}

export default Template
